<div *ngIf="form" [formGroup]="form" class="form-group row" [class.row]="horizontal">
  <label [ngClass]="horizontal ? 'col-sm-' + titleWidth + ' col-form-label' : ''" *ngIf="field.label !== 'hidden'"
         [attr.for]="field.key">{{field.label}}</label>

  <div [ngClass]="horizontal ? 'col-sm-' + dataWidth : ''" [ngSwitch]="field.controlType">

    <input *ngSwitchCase="'input'" [formControlName]="field.key" class="form-control"
           [id]="field.key" [type]="field.type" (change)="field.onChange($event, form)"
           [ngClass]="{'is-invalid': !isValid(), 'is-valid': isValid()}">

    <textarea *ngSwitchCase="'textarea'" [formControlName]="field.key" class="form-control"
              [id]="field.key" [rows]="field.rows"
              [ngClass]="{'is-invalid': !isValid(), 'is-valid': isValid()}">
    </textarea>

    <select *ngSwitchCase="'dropdown'" [id]="field.key" [formControlName]="field.key" class="custom-select">
      <option *ngFor="let opt of field.options" [value]="opt.key">{{opt.value}}</option>
    </select>

    <select *ngSwitchCase="'multiselect'" [id]="field.key" [formControlName]="field.key" size="3" multiple
            class="custom-select">
      <option *ngFor="let opt of field.options" [value]="opt.key">{{opt.value}}</option>
    </select>

  </div>
  <!--
    <div class="alert alert-danger" *ngIf="!isValid()">{{field.label}} is required</div>
    -->
</div>
